<script>
	import {External, M} from "../external";

	export let value, onChange;
	let executeDate = (node) => {
		const target = External.$(node);
		target.datepicker({
			dateFormat: External.WebsiteSettings.getDateFormat() === "us" ? "mm/dd/yy" : "dd/mm/yy",
			currentText: M.TIME_NOW,
			closeText: M.CLOSE,
			timeText: M.TIME,
			hourText: M.TIME_HOUR,
			minuteText: M.TIME_MINUTE,
			secondText: M.SECONDS,
			monthNamesShort: [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC],
			monthNames: [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER],
			onSelect: function (dateText) {
				value = External.$(this).datepicker("getDate").getTime();
				onChange(value, dateText);
			}
		}); //.datepicker('setDate', new Date());

		if (value) {
			target.datepicker("setDate", new Date(value));
		}

		return {
			destroy() {
				target.datepicker("destroy");
			}
		};
	};
</script>

<input use:executeDate type="text" class="datepicker" placeholder={M.SELECT_DATE}/>
